import {CSSProperties} from 'react';
import styles from './TypewritterEffect.module.scss';

export interface TypewritterEffectProps {
  text: string;
  className?: string;
  animation?: AnimationSettings;
}

interface AnimationSettings {
  stop?: boolean;
  endCallback?(): void;
  speed?: number;
  lineHeight?: number;
  backgroundColor?: string;
  charsPerLine?: number;
}

const animationDefaultSettings: AnimationSettings = {
  stop: false,
  speed: 2,
  lineHeight: 1.4,
  backgroundColor: '#FEFEFE',
  charsPerLine: 33,
};

function TypewritterEffect({
  text,
  animation,
  className = '',
}: TypewritterEffectProps): JSX.Element {
  const animationSettings = {...animationDefaultSettings, ...animation};

  const CSS_VARIABLES = {
    '--messageLines':
      Math.round(text?.length / animationSettings.charsPerLine!) || 1,
    '--lineHeight': `${animationSettings.lineHeight}rem`,
    '--timePerLine': `${animationSettings.speed}s`,
    '--backgroundColor': `${animationSettings.backgroundColor}`,
  } as CSSProperties;

  return (
    <p
      data-testid="message"
      className={`${styles.typewritter} ${className}`}
      style={CSS_VARIABLES}
      data-stopanimation={animationSettings?.stop}
      onAnimationEnd={() => {
        animationSettings?.endCallback?.();
      }}
    >
      {text}
    </p>
  );
}

export default TypewritterEffect;
